"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollPosition = exports.scrollElement = exports.scrollBottom = exports.scrollTop = void 0;
const store_1 = require("svelte/store");
const store_2 = require("../store");
const globalOptions_1 = require("../internal/globalOptions");
const utils_1 = require("../shared/utils");
const scrolling_1 = __importDefault(require("../shared/scrolling"));
const globalOptions = (0, globalOptions_1.getGlobalOptions)();
/**
 * Scroll to the top of the page
 *
 * @param options - An optional param with global options
 */
const scrollTop = (options) => {
    const opts = Object.assign(globalOptions, options);
    (0, scrolling_1.default)(0, opts);
};
exports.scrollTop = scrollTop;
/**
 * Scroll to the end of the page
 *
 * @param options - An optional param with global options
 */
const scrollBottom = (options) => {
    const opts = Object.assign(globalOptions, options);
    const body = document.body;
    const html = document.documentElement;
    const end = Math.max(body.scrollHeight, body.offsetHeight, html.scrollHeight, html.clientHeight, html.offsetHeight);
    (0, scrolling_1.default)(end, opts);
};
exports.scrollBottom = scrollBottom;
/**
 * Scroll to element
 *
 * @param reference - The element reference
 * @param options - An optional param with global options
 */
const scrollElement = (reference, options) => {
    if (!reference || typeof reference !== 'string') {
        throw new Error('scrollElement require a reference valid');
    }
    const opts = Object.assign(globalOptions, options);
    const ref = (0, utils_1.sanitize)(reference);
    const elementsList = (0, store_1.get)(store_2.elements);
    const element = (0, utils_1.getElement)(elementsList, ref);
    if (!element) {
        throw new Error(`Element reference '${ref}' not found`);
    }
    (0, scrolling_1.default)((0, utils_1.getPosition)(element), opts);
};
exports.scrollElement = scrollElement;
/**
 * Scroll to a position on the page
 *
 * @param position - The position
 * @param options - An optional param with global options
 */
const scrollPosition = (position, options) => {
    if (!position || typeof position !== 'number') {
        throw new Error('scrollPosition require a position value valid');
    }
    const opts = Object.assign(globalOptions, options);
    (0, scrolling_1.default)(position, opts);
};
exports.scrollPosition = scrollPosition;
